var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Text from "../text/Text";
import { StyledTooltipText } from "./Tooltip.style";
const TooltipText = (_a) => {
    var { id, "data-insights": insightsAttr, children } = _a, rest = __rest(_a, ["id", "data-insights", "children"]);
    return (React.createElement(StyledTooltipText, Object.assign({ id: id, "data-insights": insightsAttr }, rest),
        React.createElement(Text, { variant: "sub" }, children)));
};
export default TooltipText;
//# sourceMappingURL=TooltipText.js.map